// extracted by mini-css-extract-plugin
export default {"Box":"label-module__Box--IFZ1a","StateLabel":"label-module__StateLabel--PyTes","Text":"label-module__Text--zqylV"};